import React from "react";
import "./Downloads.css";
import DownloadsHero from "../../components/pages/Downloads/DownloadsHero/DownloadsHero";
import DownloadsDownloads from "../../components/pages/Downloads/DownloadsDownloads/DownloadsDownloads";
import Footer from "../../components/shared/Footer/Footer";
import Navbar from "../../components/shared/Navbar/Navbar";
import AboutStartNewProject from "../../components/pages/About/AboutStartNewProject/AboutStartNewProject";
import { useTranslation } from "react-i18next";
import { usePageContent } from "../../hooks/usePublicQueries";

const unwrapSectionData = (section) => {
  if (section == null) return section;
  if (typeof section === "string") {
    const t = section.trim();
    if (t.startsWith("{")) {
      try {
        const parsed = JSON.parse(t);
        if (parsed && typeof parsed === "object") return unwrapSectionData(parsed);
      } catch {
        return section;
      }
    }
    return section;
  }
  if (typeof section !== "object") return section;
  if (section.data && typeof section.data === "object") return section.data;
  return section;
};

const normalizeSectionSlug = (key) =>
  String(key || "")
    .toLowerCase()
    .replace(/[_\s-]+/g, "");

const findPageSection = (root, slug) => {
  if (!root || typeof root !== "object") return undefined;
  const target = normalizeSectionSlug(slug);
  const hit = Object.keys(root).find((k) => normalizeSectionSlug(k) === target);
  return hit != null ? root[hit] : undefined;
};

const getAboutStartNewProjectContent = (aboutRoot) =>
  unwrapSectionData(
    findPageSection(aboutRoot || {}, "startanewproject") ||
      findPageSection(aboutRoot || {}, "aboutstartnewproject")
  );

const Downloads = () => {
  const { i18n } = useTranslation();
  const { data: downloadsContent } = usePageContent("downloads", i18n.language);
  const { data: aboutContent } = usePageContent("about", i18n.language);

  return (
    <div className="downloads-page">
      <Navbar theme="dark" />
      <div className="downloads-page-content-guide">
        <DownloadsHero content={unwrapSectionData(findPageSection(downloadsContent, "hero"))} />
        <DownloadsDownloads />
        <AboutStartNewProject content={getAboutStartNewProjectContent(aboutContent)} />
      </div>
      <Footer />
    </div>
  );
};

export default Downloads;
